/**
 * @fileoverview CSS module for rendering a checkbox group
 *
 * @example
 * // Usage in component:
 * import styles from './CheckboxGroupRenderer.module.css';
 *
 * <div className={styles.container}>
 *   <div className={styles.item}>
 *     <input type="checkbox" className={styles.checkbox} />
 *     <label className={styles.label}>Option 1</label>
 *   </div>
 * </div>
 */

.container {
    border: 1px solid var(--neutural400);
    border-radius: 0.75rem;
}

.item + .item {
    border-top: 1px solid var(--neutural400);
}

.item {
    cursor: pointer;
    position: relative;
    display: flex;
    align-items: center;
    border: 1px solid transparent;
    padding: 1rem 0;
    transition: all 0.2s ease-out;
}

.item:hover,
.item:focus,
.item:active {
    z-index: 10;
    border: 1px solid var(--neutural900);
    outline: 6px solid var(--indigo300);
    border-radius: 12px;
}

.item:hover .label,
.item:focus .label,
.item:active .label {
    text-decoration: underline;
}

.item:hover .unchecked,
.item:focus .unchecked {
    border-color: var(--neutural900);
}

.label {
    cursor: pointer;
    text-underline-offset: 3px;
    padding-right: 0.5rem;
}

.checkbox {
    display: flex;
    padding-left: 1rem;
    margin-right: 0.75rem;
}

.checkbox input[type='checkbox'] {
    width: 0;
    heigth: 0;
    visibility: hidden;
}

.checkbox input[type='checkbox'] + label {
    display: flex;
}

.unchecked {
    width: 24px;
    height: 24px;
    border-radius: 4px;
    border: 2px solid var(--neutural400);
    box-sizing: border-box;
    transition: all 0.2s ease-out;
}

.error {
    outline: 6px solid var(--red300);
    border-color: var(--neutural900);
}

.errorMessage {
    color: var(--red700);
}
